// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Abladestelle, type ApiError } from "../../api";
import { useGetAbladestelle as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useAbladestelle(
  id: string,
  options: Omit<
    UseQueryOptions<Abladestelle, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): Abladestelle {
  const getter = useGetter();
  return useQuery(["abladestellen", id], () => getter(id), options).data!;
}
